var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { LabelModel } from 'src/app/story/models/labels/label.model';
import { Store, Select, Actions, ofActionCompleted } from '@ngxs/store';
import { SetNodeInfo } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Subject, Observable } from 'rxjs';
import { EngineService } from 'src/app/engine/engine.service';
import { get } from 'lodash';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ViewService } from 'src/app/view/view.service';
import { takeUntil } from 'rxjs/operators';
var ContextLabelComponent = /** @class */ (function () {
    function ContextLabelComponent(store, actions, engineService, viewService, changeDetectorRef) {
        this.store = store;
        this.actions = actions;
        this.engineService = engineService;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        this.ngUnsubscribe = new Subject();
    }
    Object.defineProperty(ContextLabelComponent.prototype, "label", {
        get: function () {
            return this._label;
        },
        // ---------- Input / Output ----------
        set: function (value) {
            this._label = value;
            this.setLabelNode();
        },
        enumerable: true,
        configurable: true
    });
    // ---------- Lifecycle Events ----------
    ContextLabelComponent.prototype.ngOnInit = function () {
        this.initInfoListeners();
    };
    ContextLabelComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Class Methods ----------
    ContextLabelComponent.prototype.setLabelNode = function () {
        var objectId = get(this.label, 'objectId');
        if (objectId) {
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            this.node = this.engineService.getNode(viewGraph, objectId);
        }
        else {
            this.node = null;
        }
        this.changeDetectorRef.markForCheck();
    };
    ContextLabelComponent.prototype.initInfoListeners = function () {
        var _this = this;
        // mark "dirty" check for node updates
        this.actions
            .pipe(ofActionCompleted(SetNodeInfo), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.setLabelNode();
        });
    };
    ContextLabelComponent.prototype.handleReadMoreClick = function () {
        if (this.node) {
            this.viewService.toggleNodeInfo(true);
        }
    };
    __decorate([
        Select(EngineNodesState.getSelectedNode),
        __metadata("design:type", Observable)
    ], ContextLabelComponent.prototype, "selectedNode$", void 0);
    __decorate([
        Select(EngineNodesState.getQuerying),
        __metadata("design:type", Observable)
    ], ContextLabelComponent.prototype, "querying$", void 0);
    return ContextLabelComponent;
}());
export { ContextLabelComponent };
